// 用户相关文案
export default {
  login: 'Sign in',
  logout: 'Sign Out',
};
